import commonActions from '@/store/ui/common/actions'

const actions = { ...commonActions }

export default actions
